import { Tooltip as ChakraTooltip, type TooltipRootProps } from '@chakra-ui/react'
import { ReactNode, forwardRef } from 'react'
import { forceLight } from 'utils'
import { Portal, type PortalProps } from './providers'

export interface Props extends TooltipRootProps {
  hideArrow?: boolean
  portal?: boolean | Omit<PortalProps, 'children'>
  content: ReactNode
  contentProps?: ChakraTooltip.ContentProps
  onHoverChange?: (open: boolean) => void
}

export default forwardRef<HTMLDivElement, Props>(function Tooltip(props, ref) {
  const {
    hideArrow,
    children,
    disabled,
    portal = true,
    content,
    contentProps,
    onHoverChange,
    ...rest
  } = props

  if (disabled) return children

  return (
    <ChakraTooltip.Root
      openDelay={200}
      closeDelay={200}
      onOpenChange={
        onHoverChange
          ? details => {
              onHoverChange(
                typeof details === 'object' && 'open' in details ? details.open : Boolean(details)
              )
            }
          : undefined
      }
      {...rest}
    >
      <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>
      <Portal disabled={!portal} {...(typeof portal === 'object' ? portal : {})}>
        <ChakraTooltip.Positioner>
          <ChakraTooltip.Content
            {...forceLight}
            alignContent="center"
            backgroundColor="white"
            border="1px solid rgba(0, 0, 0, 0.1)"
            borderRadius="md"
            boxShadow="0px 4px 10px 0px rgba(0, 0, 0, 0.10)"
            p={2}
            px={3}
            ref={ref}
            {...contentProps}
          >
            {!hideArrow && (
              <ChakraTooltip.Arrow>
                <ChakraTooltip.ArrowTip background="white !important" borderColor="#dfdfdfff" />
              </ChakraTooltip.Arrow>
            )}
            {content}
          </ChakraTooltip.Content>
        </ChakraTooltip.Positioner>
      </Portal>
    </ChakraTooltip.Root>
  )
})
